import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/jackroperunning",
      name: "home_jrr",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_jrr.vue"),
    },

    {
      path: "/rowingworkoutapp",
      name: "home_row",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_row.vue"),
    },

    {
      path: "/skiingworkoutapp",
      name: "home_ski",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_ski.vue"),
    },
    {
      path: "/cyclingworkoutapp",
      name: "home_cycling",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_cycling.vue"),
    },
    {
      path: "/cycle-unit",
      name: "home_cycle",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_cycle.vue"),
    },
    {
      path: "/workoutgpt",
      name: "home_workoutgpt",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_workoutgpt.vue"),
    },
    {
      path: "/wgpt-howto-apikey",
      name: "wgpt_howto_apikey",
      component: () =>
        import(
          /* webpackChunkName: "about" */ "./views/WgptHowtoApiKey.vue"
        ),
    },
    {
      path: "/wgpt-privacy",
      name: "wgpt_privacy",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/WgptPrivacy.vue"),
    },
    {
      path: "/wgpt-terms",
      name: "wgpt_terms",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/WgptTerms.vue"),
    },

    {
      path: "/intervalsapp",
      name: "home_intervals",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_intervals.vue"),
    },

    {
      path: "/jackropetraining",
      name: "home_jrt",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home_jrt.vue"),
    },
    {
      path: "/gpx",
      name: "gpx",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/gpx.vue"),
    },

    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "/privacy",
      name: "privacy",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/privacy.vue"),
    },
    {
      path: "/support",
      name: "support",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/support.vue"),
    },

    {
      path: "/supportedrowers",
      name: "supportedrowers",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/supportedrowers.vue"),
    },

    {
      path: "/imprint",
      name: "imprint",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Imprint.vue"),
    },
    {
      path: "/cycling-terms",
      name: "cycling-terms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/CyclingTerms.vue"),
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    },
    {
      path: "/row-terms",
      name: "row-terms",
      // route level code-splitting

      component: () =>
        import(/* webpackChunkName: "about" */ "./views/CyclingTerms.vue"),
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    },
    {
      path: "/cycle-terms",
      name: "cycle-terms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/CycleTerms.vue"),
    },
    {
      path: "/ski-terms",
      name: "ski-terms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SkiTerms.vue"),
    },
    {
      path: "/interval-terms",
      name: "interval-terms",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/IntervalTerms.vue"),
    },
    {
      path: "/rowingconnect",
      name: "rowingconnect",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RowingConnect.vue"),
    },
    {
      path: "/pm5connect",
      name: "pm5connect",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RowingConnect.vue"),
    },
    {
      path: "/skiconnect",
      name: "skiconnect",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SkiConnect.vue"),
    },
  ],
});
